import { createAction } from 'redux-actions';

export const authLogin = createAction('AUTH_LOGIN');
export const authLoginRedirect = createAction('AUTH_LOGIN_REDIRECT');
export const authLogout = createAction('AUTH_LOGOUT');

export const getOAuthToken = createAction('AUTH_GET_OAUTH_TOKEN');
export const getOAuthTokenSuccess = createAction('AUTH_GET_OAUTH_TOKEN_SUCCESS');
export const getOAuthTokenFailure = createAction('AUTH_GET_OAUTH_TOKEN_FAILURE');

export const refreshedOAuthToken = createAction('AUTH_REFRESHED_OAUTH_TOKEN');

export const authSelectDataset = createAction('AUTH_DATASET_SELECTED');

export const setAuthSession = createAction('AUTH_SET_AUTH_SESSION');
export const persistAuthSession = createAction('AUTH_PERSIST_AUTH_SESSION');
